module.exports = __webpack_public_path__ + "media/images/c_2-55a77f7227433574c4ff2c93e0b33648.png";